import { FLOOR_SCREED_CDN_PATH } from '../../floor-screed-constants';

export type FloorScreedAdvantageStructure = {
  imageSrc: string;
  imageAlt: string;
  name: string;
  text: string;
};

export const FLOOR_SCREED_ADVANTAGES_LIST: FloorScreedAdvantageStructure[] = [
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/price.png/price.png`,
    imageAlt: 'Меньше стоимость работы',
    name: 'На\u00A020% дешевле',
    text: 'Машинная технология уменьшает затраты на\u00A0работу специалистов на\u00A015-20%.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/speed.png/speed.png`,
    imageAlt: 'Высыхает быстрее',
    name: 'Высыхает быстрее',
    text:
      'Сухая стяжка быстро сохнет: укладывать плитку, линолеум, ковролин, паркет или ламинат можно через 28\u00A0дней.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/one-day.png/one-day.png`,
    imageAlt: 'Высокая скорость работы',
    name: 'Сделаем за\u00A0один день',
    text: 'Подходит для разных площадей, сделаем до\u00A0200\u00A0м\u00B2 стяжки за\u00A0один день.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/flat-floor.png/flat-floor.png`,
    imageAlt: 'Ровная поверхность пола',
    name: 'Идеально ровный пол',
    text:
      'Для получения ровной поверхности на\u00A0пол устанавливаются маяки по\u00A0лазерному уровню. Допустимый перепад не\u00A0превышает 3\u00A0мм на\u00A02\u00A0метра.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/strength.png/strength.png`,
    imageAlt: 'Отсутствие трещин',
    name: 'Прочная поверхность без трещин',
    text:
      'Армированный фиброволокном раствор с\u00A0маркой прочности М200 создаёт прочную поверхность без трещин.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/advantages/guarantee.png/guarantee.png`,
    imageAlt: 'Гарантия 2 года',
    name: 'Гарантия 2\u00A0года',
    text: 'Даём 2\u00A0года гарантии по\u00A0Сервисной карте (без\u00A0карты\u00A0\u2014 1\u00A0год).',
  },
];
